import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributesValidatorsActionsComponent } from 'src/app/components/dialog/attributes/attributes-validators-actions/attributes-validators-actions.component';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { AttributeValidatorModel, PaginationInput, PaginationPageEvent, ListParams, Res, ReferenceParams, AttributeModel } from 'src/app/models';
import { ApiAttributesValidatorService, DialogModalService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-attributes-validator-list',
  templateUrl: './attributes-validator-list.component.html',
  styleUrls: ['./attributes-validator-list.component.css']
})
export class AttributesValidatorListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  validators: AttributeValidatorModel[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  attributes: AttributeModel[] = [];
  selectedOperatorsForCondition: string;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiValidatorService: ApiAttributesValidatorService,
    private notification: NotificationService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();
    this.getAttributes();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.validators = [];

    this.setListParams();

    this.apiValidatorService.getList(this.listParams).subscribe((response: Res) => {
      console.log("RESPONSE_LIST: ", response)

      if (response != null) {

        // for(let r of response.result.list){

        //   if(Object.keys(r.conditions).length != 0){
        //       this.selectedOperatorsForCondition = r.conditions['']
        //   }
          
        // }

        this.validators = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: ''
      },
      object: 'attrs_presets',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  */
   getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        type: ['INPUT', 'TEXTAREA']
      }
    }

    this.subscriptions.add(
      this.apiValidatorService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS: ", response);

        if (response != null) {

          this.attributes = response.result;
        }
      })
    );

  }

  /**
   * 
   * @param attribute_id 
   * @returns 
   */
  conditionsName(attribute_id:string){

   return this.attributes.find(val=> val.id == attribute_id).name;

  }

  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

    /**
  * 
  * @param ids 
  */
    onConfirm(ids: string[]) {

      let message = 'Вы действительно хотите удалить?';
  
      this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
        (result) => {
  
          if (result) {
  
            this.onDelete(ids);
          }
        },
        () => { console.log('Rejected!'); }
      );
  
    }

  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiValidatorService.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.validators.filter(val => val.checked).map(({ id }) => id))];
    this.onConfirm(ids);
  }

  /**
   * 
   */
   onCreate(): void {

    let data = {
      attr_id: ''
    }

    this.dialogModal.open(data, AttributesValidatorsActionsComponent).then(
      (result) => {

        if (result) {
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
   onEdit(validatorId): void {

    let data = {
      attr_id: validatorId
    }

    this.dialogModal.open(data, AttributesValidatorsActionsComponent).then(
      (result) => {

        if (result) {
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.validators[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.validators.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.validators.length == 0) return false;

    return this.validators.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.validators.length;
    let pc = this.validators.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.validators.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


}
